module.exports = __webpack_public_path__ + "img/login.acce0c7a.png";